import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Confirmation prompt shown when a match term has a stray (unbalanced) leading or
 * trailing quote character (see DATA-12320). A quote can be a legitimate part of a
 * term, so rather than silently stripping it we let the admin decide whether to
 * remove the likely import artifact or keep the term exactly as typed.
 */
export default function StrayQuoteConfirmDialog({ term, cleanedTerm, onRemove, onKeep, ...overlay }) {
  const { t } = useTranslation()
  return (
    <DialogOverlay
      {...overlay}
      title={t('tools.lists.strayQuote.title', 'Possible stray quote')}
      subtitle={t(
        'tools.lists.strayQuote.subtitle',
        'This term begins or ends with a quote character that has no matching pair. Stray quotes are usually an import artifact and make the term unmatchable.'
      )}
    >
      <Paragraph>{t('tools.lists.strayQuote.termAsTyped', 'As typed: {term}', { term })}</Paragraph>
      <Paragraph>
        {t('tools.lists.strayQuote.termCleaned', 'Without the stray quote: {term}', { term: cleanedTerm })}
      </Paragraph>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={onRemove}>
            {t('tools.lists.strayQuote.remove', 'Remove quote & save')}
          </Button>
          <Button emphasis="medium" onClick={onKeep}>
            {t('tools.lists.strayQuote.keep', 'Keep as typed')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
